import axios from "axios";
import { getToken } from "./authService";

// let stagingRemoteUrl = "https://ukicnews-staging-5e93623e3962.herokuapp.com/api/v1/";
let productionRemoteUrl = "https://ukicnews-prod-5c6f1e6bfdb0.herokuapp.com/api/v1/";
// let localUrl = "https://e61f547e2322.ngrok-free.app/api/v1/";

const httpService = axios.create({
    baseURL: productionRemoteUrl,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
    },
});

export default httpService;
